"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _ErrorMessages = _interopRequireDefault(require("../../ErrorMessages"));

var _Message = require("../../../ui-components/Message");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _constants = require("@insided/shared/constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FederatedSearchSyncStatus = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FederatedSearchSyncStatus, _Component);

  var _super = _createSuper(FederatedSearchSyncStatus);

  function FederatedSearchSyncStatus(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FederatedSearchSyncStatus);
    _this = _super.call(this, props);

    _this.setState({
      isFederatedSearchActive: props.isFederatedSearchActive
    });

    _this.onSync = _this.onSync.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FederatedSearchSyncStatus, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.federatedSearchInitialSyncCompleted !== prevProps.federatedSearchInitialSyncCompleted) {
        this.setState({
          initialSyncCompleted: this.props.federatedSearchInitialSyncCompleted
        });
      }

      if (this.props.isFederatedSearchActive !== prevProps.isFederatedSearchActive) {
        this.setState({
          isFederatedSearchActive: this.props.isFederatedSearchActive
        });
      }
    }
  }, {
    key: "onSync",
    value: function () {
      var _onSync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        var _this$props, syncUrl, syncedDataType;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, syncUrl = _this$props.syncUrl, syncedDataType = _this$props.syncedDataType;
                this.setState({
                  syncInProgress: true,
                  messageType: null,
                  initialSyncCompleted: false
                });
                _context.next = 4;
                return _axios.default.post(syncUrl, []).then(function (res) {
                  var successMessage = "".concat(res.data.count, " ").concat(syncedDataType, " are successfully synchronized!");

                  _this2.setState({
                    syncInProgress: false,
                    messageType: 'success',
                    message: successMessage
                  });
                }).catch(function (error) {
                  _this2.setState({
                    syncInProgress: false
                  });

                  if (error.response === undefined) {
                    _this2.setState({
                      messageType: 'error',
                      message: _ErrorMessages.default.internetConnection
                    });

                    return;
                  }

                  _this2.setState({
                    messageType: 'error',
                    message: 'Sorry, synchronisation failed, please try again.'
                  });
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSync() {
        return _onSync.apply(this, arguments);
      }

      return onSync;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          syncInProgress = _this$state.syncInProgress,
          message = _this$state.message,
          messageType = _this$state.messageType,
          initialSyncCompleted = _this$state.initialSyncCompleted,
          isFederatedSearchActive = _this$state.isFederatedSearchActive;

      if (!isFederatedSearchActive) {
        return null;
      }

      if (initialSyncCompleted) {
        return (0, _preact.h)(FederatedSearchSuccess, {
          message: message,
          messageType: messageType,
          onSync: this.onSync
        });
      }

      return (0, _preact.h)("div", {
        className: "integrations-salesforce__federated-search-sync-status integration-salesforce-sync-status"
      }, syncInProgress && (0, _preact.h)(_Message.Message, {
        variant: "loading",
        fullWidth: true,
        text: "Content synchronization is in progress."
      }), !syncInProgress && messageType === 'error' && (0, _preact.h)(_Message.Message, {
        fullWidth: true,
        variant: "warning"
      }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, message), (0, _preact.h)(_Button.default, {
        className: "button-sync-now",
        title: "Sync now",
        startIcon: "sync",
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this3.onSync();

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      }))), !syncInProgress && (messageType === 'success' || messageType === undefined) && (0, _preact.h)(FederatedSearchSuccess, {
        message: message,
        messageType: messageType,
        onSync: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this3.onSync();

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))
      }));
    }
  }]);
  return FederatedSearchSyncStatus;
}(_preact.Component);

var FederatedSearchSuccess = function FederatedSearchSuccess(_ref3) {
  var messageType = _ref3.messageType,
      message = _ref3.message,
      onSync = _ref3.onSync;
  var isVisibleFor = messageType === 'success' ? 5000 : false;
  return (0, _preact.h)("div", null, messageType === 'success' ? (0, _preact.h)(_AlertComponent.default, {
    messageType: messageType,
    message: message,
    sticky: true,
    renderHTML: true,
    isVisibleFor: isVisibleFor
  }) : null, (0, _preact.h)(_Message.Message, {
    fullWidth: true,
    variant: "success"
  }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "The search index is updated automatically every day. Run a synchronization if you\u2019d like to apply content updates to ", _constants.PLATFORM_BRAND_NAME, " immediately."), (0, _preact.h)(_Button.default, {
    className: "button-sync-now",
    title: "Sync now",
    startIcon: "sync",
    onClick: function onClick() {
      return onSync();
    }
  }))));
};

var _default = FederatedSearchSyncStatus;
exports.default = _default;